export var GdsgInventoryReportFrequency;
(function (GdsgInventoryReportFrequency) {
    GdsgInventoryReportFrequency["GDSG_INVENTORY_REPORT_FREQUENCY_DAILY"] = "DAILY";
    GdsgInventoryReportFrequency["GDSG_INVENTORY_REPORT_FREQUENCY_WEEKLY"] = "WEEKLY";
})(GdsgInventoryReportFrequency || (GdsgInventoryReportFrequency = {}));
